import { StrapiMedia } from "~/shared-types";

export const getMediaType = (media?: StrapiMedia | null) => {
  if (media?.attributes.mime.includes("image")) return "image";
  if (media?.attributes.mime.includes("video")) return "video";
  return "other";
};
